<div class="max-w-7xl mx-auto p-6">
  <h2 class="text-2xl font-bold mb-6 text-base-content">USDM Workflow Progress</h2>

  <div class="space-y-2">
    @for (state of usdmStatus(); track state.name; let idx = $index) {
    <div class="collapse collapse-plus bg-base-100 border border-base-300">
      <input type="radio" name="usdm-accordion" [checked]="currentRunningState() === state.name" />
      <div class="collapse-title font-semibold">
        <div class="flex items-center justify-between w-full">
          <div class="flex items-center gap-3">
            <span class="inline-block w-2.5 h-2.5 rounded-full" [class.bg-warning]="state.status === 'current'"
              [class.bg-success]="state.status === 'success'" [class.bg-error]="state.status === 'error'"
              [class.bg-base-300]="state.status === 'pending'" aria-hidden="true"></span>
            <span class="font-medium text-base-content">{{ state.name }}</span>
            <span class="badge badge-sm" [class.badge-ghost]="state.status === 'pending'"
              [class.badge-info]="state.status === 'current'" [class.badge-success]="state.status === 'success'"
              [class.badge-error]="state.status === 'error'">
              @if (state.status === 'pending') { Pending }
              @if (state.status === 'current') { Running }
              @if (state.status === 'success') { Finished }
              @if (state.status === 'error') { Failed }
            </span>
          </div>
          <div class="flex items-center">
            @if (state.status === 'current') {
            <span class="loading loading-spinner loading-lg text-info mr-6" aria-label="Running"></span>
            }
          </div>
        </div>
      </div>
      <div class="collapse-content text-sm">
        <div class="space-y-2">
          @if (!state.updates || state.updates.length === 0) {
          <div class="text-sm text-base-content/60">No updates yet.</div>
          } @else {
          @for (update of state.updates; track $index) {
          <div class="alert alert-outline border-1 p-3" [class.alert-info]="update.type === 'info'"
            [class.alert-success]="update.type === 'success'" [class.alert-error]="update.type === 'error'">
            <div class="flex items-start gap-2">
              <span>
                @if (update.type === 'info') { ℹ️ }
                @if (update.type === 'success') { ✅ }
                @if (update.type === 'error') { ⚠️ }
              </span>
              <div class="text-sm leading-snug text-base-content">{{ update.message }}</div>
            </div>
          </div>
          }
          }
        </div>
      </div>
    </div>
    }
  </div>
</div>
